import React from 'reactn';
import { DeliveryBackupCardStyled } from './DeliveryBackupCardStyled';
import { useEffect, useState } from 'react';
import Icon from '../icons/ReturnIcons';

const BASE_URL = window.autoAddressBaseUrl

const DeliveryBackupCard = ({addressType, profileData, setAddressToDelete, setEditMode}) => {
    const [selectedAddress, setSelectedAddress] = useState();
    const [addresses, setAddresses] = useState([]);
    const [deliveryType, setDeliveryType] = useState("");


    const deliveryManagerTypehandler = () => {
        switch (addressType.deliveryManagerType) {
            case "SAFE_PLACE":
                    return "Safe spot";
            case "SPECIFIED_NEIGHBOUR":
                    return "To a neighbour";
            default:
                return "no value"
        }
     }




    useEffect(() => {
        if(addressType  && profileData && profileData.length) {
            setDeliveryType(deliveryManagerTypehandler());
            const filteredData = profileData.filter(el => el.id=== addressType.addressId);
            setSelectedAddress(filteredData);
            if (filteredData && filteredData.length) {
                const newAddresses = [];
                if (filteredData[0].addressLine1) newAddresses.push(filteredData[0].addressLine1);
                if (filteredData[0].addressLine2) newAddresses.push(filteredData[0].addressLine2);
                if (filteredData[0].addressLine3) newAddresses.push(filteredData[0].addressLine3);
                if (filteredData[0].addressLine4) newAddresses.push(filteredData[0].addressLine4);
                if (filteredData[0].town) newAddresses.push(filteredData[0].town);
                if (filteredData[0].county) newAddresses.push(filteredData[0].county);
                if (filteredData[0].eircode) newAddresses.push(filteredData[0].eircode);
        
                setAddresses(newAddresses);
            }
        }
     } , [addressType, profileData]);

    const addressToDeleteHandler = () => {
        setAddressToDelete({
            id: addressType.groupId,
            addId: addressType.addressId,
            address: addresses,
            deliveryType: deliveryType,
            addressType: addressType.customerInstruction
        })
     }


     const setupdateDataHandler = () => {
        setEditMode({
            id: addressType.addressId,
            groupId: addressType.groupId,
            deliveryType: deliveryType,
            addressType: addressType.deliveryManagerType === "SAFE_PLACE" ? addressType.customerInstruction : null,
            neighboursName: addressType.deliveryManagerType === "SPECIFIED_NEIGHBOUR" ? addressType.customerInstruction.split(",")[0].trim() : null,
            neighboursAddress: addressType.deliveryManagerType === "SPECIFIED_NEIGHBOUR" ? addressType.customerInstruction.split(",")[1].trim() : null,
        })
     }



              
    return (
        <DeliveryBackupCardStyled>
           <div className='sectionWrapper'>
            <span className='mainTitle'>My delivery backup</span>
            <span className='content grayText'>This instruction will automatically activate if there is no answer at this delivery address, and if the sender has provided the correct Eircode</span>
           </div>
           <div className='sectionWrapper'>
           {selectedAddress ? <span className='mainTitle'>{selectedAddress[0].displayName} address</span> : ""}
           {addresses ? <span className='content'>
                {addresses.map((address, index) => {
                     return <span className='content addressContent' key={index}>{address}</span>
                }
                )}
           </span> : "no data"}

          
           </div>
           <div className='sectionWrapper'>
           <span className='linkSection'>
            <Icon src='infoIcon' /> Address can be edited on <a className='gtm-linkclick'  href={`/myAccount/Addresses`} target="_self" rel="noopener noreferrer">
                                    address book
                                </a>
           </span>
           </div>
           <div className='sectionWrapper'>
           <span className='mainTitle'>Delivery backup</span>
           <span className='content semiTitle'>{deliveryType}</span>
           <span className='content'>{`'${addressType.customerInstruction}'`}</span>
           </div>
           <div className='sectionWrapper handlersWrapper'>
           <span className='handlers' onClick={addressToDeleteHandler}>
                <Icon src="deleteIcon" /> Delete
            </span>
            <span className='handlers greenHandler' onClick={setupdateDataHandler}>
                <Icon src="editIcon"  /> Edit
            </span>
           </div>
        </DeliveryBackupCardStyled>
    );
};

export default DeliveryBackupCard;